export class PermissionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, PermissionError.prototype);
  }
}
